export * from './gerenciamento-comissao.component'
export * from './crud/comissao-crud.component'
export * from './crud/etapa1/etapa1.component'
export * from './crud/etapa2/etapa2.component'


// WEBPACK FOOTER //
// ./src/app/gerenciamento-comissao/index.ts